var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenBrandedUsdc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "token-branded:usdc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8797 5L15.4214 7.06706V16.9329L10.8797 19L9.19922 18.0052V5.99477L10.8797 5ZM10.6384 5.71486L10.0266 6.07659L10.6384 6.29622V5.71486ZM10.6384 6.81729L9.71199 6.48139V17.5186L10.6384 17.1827V6.81729ZM11.1512 16.9975V7.00246L13.4479 7.83359V16.1664L11.1512 16.9975ZM10.6384 17.7038L10.0266 17.9234L10.6384 18.2851V17.7038ZM11.1512 18.3411V17.5186L13.7108 16.5927L14.4778 16.8296L11.1512 18.3454V18.3411ZM14.9087 16.4506L13.9607 16.1578V7.84651L14.9087 7.55798V16.4506ZM14.4778 7.17902L13.7108 7.41157L11.1512 6.4857V5.66318L14.4735 7.17472L14.4778 7.17902Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenBrandedUsdc);
export default __webpack_public_path__ + "static/media/token-branded_usdc.8e2249bbaf8e52d79c6c42b538e9bfc2.svg";
export { ForwardRef as ReactComponent };